import styled from "@emotion/styled";
export const StyledContentAfterContainer = styled("div")`
    margin: ${getMargin};
    box-sizing: content-box;
`;
function getMargin(_ref) {
  let {
    validationState,
    isFocused,
    focusMode,
    themeMode
  } = _ref;
  if (themeMode.includes("ursa") && (validationState === "error" || isFocused && focusMode !== "keyboard")) {
    return `var(--sds--textarea--content-after--margin-top, 6px) var(--sds--textarea--content-after--margin-right, 3px) var(--sds--textarea--content-after--margin-bottom, 3px) var(--sds--textarea--content-after--margin-left, 3px)`;
  } else {
    return `var(--sds--textarea--content-after--margin-top, 7px) var(--sds--textarea--content-after--margin-right, 4px) var(--sds--textarea--content-after--margin-bottom, 3px) var(--sds--textarea--content-after--margin-left, 3px)`;
  }
}
//# sourceMappingURL=StyledContentAfterContainer.js.map